// pages/Support.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack } from "react-icons/io";
import { FiMail, FiPhone, FiMessageCircle, FiClock, FiHeart } from "react-icons/fi";

const Support = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 pb-12">
      {/* 🔝 Sticky Header */}
      <div className="sticky top-0 z-30 bg-white/80 backdrop-blur-md border-b px-4 py-4 flex items-center justify-between">
        <button
          onClick={() => navigate(-1)}
          className="p-2 hover:bg-gray-100 rounded-full transition text-gray-700 flex items-center gap-1"
        >
          <IoMdArrowBack size={24} />
          <span className="text-xs font-black uppercase tracking-widest">Back</span>
        </button>
        <h1 className="text-lg font-black text-gray-900 tracking-tight pr-10">Help Center</h1>
        <div />
      </div>

      <div className="max-w-xl mx-auto px-6 pt-10">
        {/* 👋 Welcome Section */}
        <div className="text-center mb-12">
          <div className="w-20 h-20 bg-orange-100 text-orange-600 rounded-[2.5rem] flex items-center justify-center mx-auto mb-6 shadow-lg shadow-orange-100">
            <FiHeart size={40} strokeWidth={2.5} />
          </div>
          <h1 className="text-3xl font-black text-gray-900 mb-4">Support</h1>
          <p className="text-gray-500 font-medium leading-relaxed">
            <span className="text-orange-600 font-bold">OurASAP</span> was created to make everyday life easier for everyone. 
            Sell that product ASAP! Need help or have suggestions? We’re here for you.
          </p>
        </div>

        {/* 💳 Contact Cards */}
        <div className="space-y-4">
          {/* Email Card */}
          <a
            href="mailto:ourasapservice@gmail.com"
            className="group flex items-center p-6 bg-white rounded-[2rem] shadow-xl shadow-gray-200/50 border border-gray-100 transition-all hover:border-orange-200 active:scale-[0.98]"
          >
            <div className="w-14 h-14 bg-blue-50 text-blue-600 rounded-2xl flex items-center justify-center shrink-0 group-hover:bg-blue-600 group-hover:text-white transition-colors">
              <FiMail size={24} />
            </div>
            <div className="ml-5">
              <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Send an Email</p>
              <p className="text-sm font-black text-gray-900 break-all">ourasapservice@gmail.com</p>
            </div>
          </a>

          {/* Phone/WhatsApp Card */}
          <a
            href="tel:+2349026235719"
            className="group flex items-center p-6 bg-white rounded-[2rem] shadow-xl shadow-gray-200/50 border border-gray-100 transition-all hover:border-green-200 active:scale-[0.98]"
          >
            <div className="w-14 h-14 bg-green-50 text-green-600 rounded-2xl flex items-center justify-center shrink-0 group-hover:bg-green-600 group-hover:text-white transition-colors">
              <FiPhone size={24} />
            </div>
            <div className="ml-5">
              <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Phone or Whatsapp</p>
              <p className="text-lg font-black text-gray-900">09026235719</p>
            </div>
          </a>
        </div>

        {/* 🕒 Availability Section */}
        <div className="mt-12 bg-gray-100/50 rounded-[2rem] p-8 text-center border border-dashed border-gray-200">
          <div className="flex items-center justify-center gap-2 text-gray-400 mb-2">
            <FiClock />
            <span className="text-[10px] font-black uppercase tracking-[0.2em]">Operating Hours</span>
          </div>
          <p className="text-sm font-bold text-gray-600 leading-relaxed">
            Our support team is available <br />
            <span className="text-gray-900">Monday – Sunday, 9am – 6pm.</span>
          </p>
        </div>

        {/* 🏷 Version/Footer */}
        <div className="mt-10 text-center">
          <p className="text-[10px] font-black text-gray-300 uppercase tracking-widest">
            Always Fast • Always Reliable • OurASAP
          </p>
        </div>
      </div>
    </div>
  );
};

export default Support;